import React from 'react';
import { Link } from 'react-router-dom';
import heroIllustration from '../assets/pureaum-illustration.svg';
import verificationCartoon from '../assets/ChatGPT Image Jan 3, 2026, 12_20_58 AM.png';

// Prevention-first, text-polished landing page (keeps palette/components/layout)

const cardClasses =
  'bg-white rounded-xl p-4 sm:p-6 shadow-sm border border-gray-100 h-full';

type NewsArticle = {
  title: string;
  source: string;
  tag: string;
  url: string;
};

const NEWS_ARTICLES: NewsArticle[] = [
  {
    title: 'Fake ghee making unit busted in Jaipur, 4 held',
    source: 'Times of India',
    tag: 'Adulteration',
    url: 'https://timesofindia.indiatimes.com/city/jaipur/fake-ghee-making-unit-busted-in-jaipur-4-held/articleshow/126109498.cms',
  },
  {
    title: 'Officials seize over 14 L worth of adulterated paneer in crackdown',
    source: 'Times of India',
    tag: 'Adulteration',
    url: 'https://timesofindia.indiatimes.com/city/raipur/officials-seize-over-14-l-worth-of-adulterated-paneer-in-crackdown/articleshow/126125110.cms',
  },
  {
    title: '750 sacks of coloured roasted chickpeas seized in Gorakhpur',
    source: 'Navbharat Times',
    tag: 'Contamination',
    url: 'https://navbharattimes.indiatimes.com/state/uttar-pradesh/gorakhpur/750-sacks-colored-roasted-chickpeas-seized-in-gorakhpur-supplies-came-from-chhattisgarh-and-madhya-pradesh/articleshow/126035453.cms',
  },
  {
    title: 'Food safety department seized 33.5 quintal poha in Kota',
    source: 'Navbharat Times',
    tag: 'Adulteration',
    url: 'https://navbharattimes.indiatimes.com/state/rajasthan/kota/poha-breakfast-can-be-dangerous-read-why-food-safety-department-seized-33-quintal-poha-in-kota-over-adulteration-fears/articleshow/126136451.cms',
  },
  {
    title: 'Fake desi ghee factory busted in Punjab',
    source: 'Times of India',
    tag: 'Adulteration',
    url: 'https://timesofindia.indiatimes.com/life-style/food-news/fake-desi-ghee-factory-busted-in-punjab-how-exactly-is-fake-ghee-made-and-how-to-spot-it/articleshow/124737410.cms',
  },
];

const NewsCard: React.FC<{ article: NewsArticle }> = ({ article }) => (
  <div className={cardClasses}>
    <div className="flex items-center justify-between mb-3">
      <span
        className="px-2 py-1 rounded-full text-xs font-semibold"
        style={{ backgroundColor: '#EAF2FF', color: '#0A2A4A' }}
      >
        {article.tag}
      </span>
      <span className="text-xs font-semibold" style={{ color: '#0A2A4A' }}>
        {article.source}
      </span>
    </div>
    <h3 className="font-semibold text-lg mb-2" style={{ color: '#0A2A4A' }}>
      <a
        href={article.url}
        target="_blank"
        rel="noreferrer noopener"
        className="hover:underline"
        style={{ color: '#0A2A4A' }}
      >
        {article.title}
      </a>
    </h3>
    <a
      href={article.url}
      target="_blank"
      rel="noreferrer noopener"
      className="text-xs font-semibold hover:underline"
      style={{ color: '#FF7A29' }}
    >
      Read article
    </a>
  </div>
);

const LandingPage: React.FC = () => {
  return (
    <div className="bg-white font-sans text-gray-900">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 fixed w-full top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex justify-between items-center">
            <div className="text-2xl font-bold" style={{ color: '#0A2A4A' }}>
              Pureaum
            </div>
            <div className="flex items-center space-x-4">
              <div className="hidden sm:flex items-center space-x-6">
                <Link
                  to="/login"
                  className="font-medium transition-colors duration-200 hover:underline"
                  style={{ color: '#0A2A4A' }}
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  className="px-4 py-2 rounded-lg font-medium border-2 transition-all duration-200 hover:bg-opacity-10"
                  style={{
                    color: '#0A2A4A',
                    borderColor: '#0A2A4A',
                    backgroundColor: 'transparent',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#0A2A4A';
                    e.currentTarget.style.color = 'white';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#0A2A4A';
                  }}
                >
                  Register
                </Link>
                <Link
                  to="/trial-registration"
                  className="px-4 py-2 rounded-lg font-medium transition-all duration-200"
                  style={{
                    color: 'white',
                    backgroundColor: '#FF7A29',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#E6691F';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#FF7A29';
                  }}
                >
                  Start Free Trial
                </Link>
              </div>
            </div>
          </div>
          <div className="mt-4 flex flex-col gap-2 sm:hidden">
            <Link
              to="/login"
              className="w-full px-4 py-2 rounded-lg font-medium text-center border transition-colors duration-200"
              style={{ color: '#0A2A4A', borderColor: '#E5E7EB' }}
            >
              Login
            </Link>
            <Link
              to="/register"
              className="w-full px-4 py-2 rounded-lg font-medium text-center border-2 transition-colors duration-200"
              style={{ color: '#0A2A4A', borderColor: '#0A2A4A' }}
            >
              Register
            </Link>
            <Link
              to="/trial-registration"
              className="w-full px-4 py-2 rounded-lg font-semibold text-center transition-colors duration-200"
              style={{ color: 'white', backgroundColor: '#FF7A29' }}
            >
              Start Free Trial
            </Link>
          </div>
        </div>
      </header>

      {/* HERO */}
      <section className="pt-28 pb-16 sm:pt-32 sm:pb-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div>
              <div className="relative">
                <h1
                  className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 leading-tight"
                  style={{ color: '#0A2A4A' }}
                >
                  Prevent counterfeit physical goods before they damage your brand.
                </h1>
                <div
                  className="absolute -bottom-2 left-0 w-24 h-1 rounded"
                  style={{ backgroundColor: '#00C2D1' }}
                ></div>
              </div>
              <h2
                className="text-base sm:text-xl mb-4 mt-8 max-w-2xl"
                style={{ color: '#2B2B2B' }}
              >
                Pureaum helps manufacturers reduce counterfeit risk in physical goods through early prevention and clear risk awareness.
              </h2>
              <p className="text-xs sm:text-sm mb-6 font-medium" style={{ color: '#0A2A4A' }}>
                Designed for manufacturers of food, pharma, luxury, and consumer goods.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/trial-registration"
                  className="w-full sm:w-auto px-8 py-3 rounded-lg font-semibold transition-colors duration-200 text-center"
                  style={{ backgroundColor: '#FF7A29', color: 'white' }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = '#E6691F')
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = '#FF7A29')
                  }
                >
                  Start Free Trial
                </Link>
                <Link
                  to="/contact-sales"
                  className="w-full sm:w-auto px-8 py-3 rounded-lg font-semibold text-center border-2 transition-all duration-200"
                  style={{ color: '#0A2A4A', borderColor: '#0A2A4A' }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#0A2A4A';
                    e.currentTarget.style.color = 'white';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#0A2A4A';
                  }}
                >
                  Contact Sales
                </Link>
                <Link
                  to="/learn-how"
                  className="w-full sm:w-auto px-6 py-3 rounded-lg font-medium text-center border transition-all duration-200"
                  style={{ color: '#0A2A4A', borderColor: '#E5E7EB' }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#F9FAFB';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                >
                  Learn how
                </Link>
              </div>
            </div>
            <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
              <img
                src={heroIllustration}
                alt="Pureaum system flow: Producer creates tagged products, retail shelf scanning triggers cloud intelligence for risk detection, leading to protected customers"
                className="w-full h-auto"
                style={{
                  maxWidth: '100%',
                  height: 'auto',
                  maxHeight: '380px',
                  objectFit: 'contain',
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* WHAT WE PREVENT */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl sm:text-3xl font-bold" style={{ color: '#0A2A4A' }}>
              What Pureaum prevents
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
            {[
              'Copied physical products entering the market',
              'Unauthorized duplication of packaging and labels',
              'Gray-market diversion and parallel selling',
              'Brand trust loss before customers can react',
            ].map((item, idx) => (
              <div key={idx} className={cardClasses}>
                <h3
                  className="font-semibold mb-2 text-lg"
                  style={{ color: '#0A2A4A' }}
                >
                  {item}
                </h3>
              </div>
            ))}
          </div>
          <p
            className="text-center font-semibold mt-6"
            style={{ color: '#0A2A4A' }}
          >
            Pureaum focuses on prevention — not post-incident investigation.
          </p>
        </div>
      </section>

      {/* WHY HARD */}
      <section className="py-16" style={{ backgroundColor: '#F4F4F5' }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <h2
            className="text-2xl sm:text-3xl font-bold mb-6 text-center"
            style={{ color: '#0A2A4A' }}
          >
            Why counterfeiting is hard to stop
          </h2>
          <ul className="space-y-3 sm:space-y-4 text-base sm:text-lg">
            <li className="flex">
              <span className="w-3 h-3 rounded-full mt-2 mr-4 flex-shrink-0" style={{ backgroundColor: '#00C2D1' }}></span>
              <span style={{ color: '#2B2B2B' }}>
                Physical goods are easy to copy once they leave the factory.
              </span>
            </li>
            <li className="flex">
              <span className="w-3 h-3 rounded-full mt-2 mr-4 flex-shrink-0" style={{ backgroundColor: '#00C2D1' }}></span>
              <span style={{ color: '#2B2B2B' }}>
                Visual inspection and packaging alone cannot detect reuse.
              </span>
            </li>
            <li className="flex">
              <span className="w-3 h-3 rounded-full mt-2 mr-4 flex-shrink-0" style={{ backgroundColor: '#00C2D1' }}></span>
              <span style={{ color: '#2B2B2B' }}>
                Most systems detect problems only after customers complain.
              </span>
            </li>
          </ul>
        </div>
      </section>

      {/* OUR APPROACH */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl sm:text-3xl font-bold" style={{ color: '#0A2A4A' }}>
              Our approach to counterfeit prevention
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              'Cloud Scan Intelligence monitors real-world product behavior and risk signals.',
              'Outer QR collects telemetry by default; Inner QR is an optional second line when risk or business rules require it.',
              'When risk appears, verification is stepped up automatically with minimal friction.',
            ].map((item, idx) => (
              <div key={idx} className={cardClasses}>
                <p className="text-sm" style={{ color: '#2B2B2B' }}>
                  {item}
                </p>
              </div>
            ))}
          </div>
          <p className="mt-6 text-sm" style={{ color: '#2B2B2B' }}>
            Pureaum does not accuse products — it reduces risk.
          </p>
        </div>
      </section>

      {/* DIAGRAM: WHERE PUREAUM REDUCES RISK */}
      <section className="py-16" style={{ backgroundColor: '#F4F4F5' }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl sm:text-3xl font-bold mb-8" style={{ color: '#0A2A4A' }}>
            Where Pureaum reduces risk
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-center">
            {[
              { title: 'Manufacturing', note: 'Physical products are tagged.' },
              { title: 'Distribution', note: 'Movement is observed.' },
              { title: 'Retail', note: 'Risk appears before sale.' },
              { title: 'Customer', note: 'Confidence at purchase.' },
            ].map((item, idx) => (
              <div key={idx} className="bg-white rounded-lg p-5 shadow-sm border border-gray-100 h-full">
                <h3 className="font-semibold mb-2" style={{ color: '#0A2A4A' }}>
                  {item.title}
                </h3>
                <p className="text-sm" style={{ color: '#2B2B2B' }}>
                  {item.note}
                </p>
              </div>
            ))}
          </div>
          <p className="mt-4 text-sm" style={{ color: '#2B2B2B' }}>
            Pureaum acts before purchase to reduce brand risk.
          </p>
        </div>
      </section>

      {/* SEE IT IN ACTION */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-8">
            <h2 className="text-2xl sm:text-3xl font-bold" style={{ color: '#0A2A4A' }}>
              See it in action
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              A simple verification flow that adapts when risk appears.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <p className="text-sm leading-6 text-gray-700 mb-3">
                Every scan starts with a light-touch check.
                <br />
                If abnormal patterns appear—such as repeat scans, rapid city-to-city jumps, or datacenter traffic—the experience escalates automatically: inner QR verification, stronger messaging, and manufacturer alerts.
              </p>
              <p className="text-sm leading-6 text-gray-700 mb-3">
                Low friction for normal customers. Higher assurance when needed.
              </p>
              <p className="text-sm leading-6 text-gray-700">
                This keeps honest buyers moving while surfacing real risk to the people who can act on it—your team.
              </p>
            </div>
            <div className="bg-white border border-gray-100 rounded-xl shadow-sm overflow-hidden">
              <img
                src={verificationCartoon}
                alt="Cartoon showing adaptive verification flow reacting to risk signals"
                className="w-full h-auto"
                style={{
                  maxHeight: '420px',
                  objectFit: 'contain',
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS (high level) */}
      <section
        id="how-it-works"
        className="py-16"
        style={{ backgroundColor: '#F4F4F5' }}
      >
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl sm:text-3xl font-bold" style={{ color: '#0A2A4A' }}>
              How it works
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            {[
              {
                title: 'Products are tagged at manufacturing.',
                color: '#00C2D1',
              },
              {
                title: 'Buyers can verify before and after purchase.',
                color: '#FF7A29',
              },
              {
                title: 'Higher-confidence checks are used when risk appears.',
                color: '#0A2A4A',
              },
            ].map((item, idx) => (
              <div key={idx} className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                <div
                  className="w-12 h-12 mx-auto mb-4 rounded-full flex items-center justify-center text-white font-bold"
                  style={{ backgroundColor: item.color }}
                >
                  {idx + 1}
                </div>
                <p className="text-sm" style={{ color: '#2B2B2B' }}>
                  {item.title}
                </p>
              </div>
            ))}
          </div>
          <p className="mt-4 text-xs text-center" style={{ color: '#2B2B2B' }}>
            QR codes are one of the mechanisms used.
          </p>
        </div>
      </section>

      {/* THOUGHT LEADERSHIP (placeholder article) */}
      <section className="py-16" style={{ backgroundColor: '#F4F4F5' }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl sm:text-3xl font-bold mb-8" style={{ color: '#0A2A4A' }}>
            Insight
          </h2>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <h3 className="font-semibold text-xl mb-2" style={{ color: '#0A2A4A' }}>
              Why copied labels break most anti-counterfeit systems
            </h3>
            <p className="text-sm mb-4" style={{ color: '#2B2B2B' }}>
              Static identifiers can be duplicated. Effective prevention requires understanding how products behave after they enter the market.
            </p>
            <Link
              to="/learn/copied-labels"
              className="font-semibold"
              style={{ color: '#FF7A29' }}
            >
              Read article
            </Link>
          </div>
        </div>
      </section>

      {/* News/Articles section remains unchanged elsewhere */}
      {/* Counterfeit food alerts */}
      <section id="counterfeit-alerts" className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10">
            <p className="text-xs font-semibold uppercase tracking-wide" style={{ color: '#0A2A4A' }}>
              Counterfeit Food Alerts (India)
            </p>
            <h2 className="text-2xl sm:text-3xl font-bold mt-2" style={{ color: '#0A2A4A' }}>
              Food counterfeits are happening at scale.
            </h2>
            <p className="text-sm mt-3" style={{ color: '#2B2B2B' }}>
              Pureaum combines Cloud Scan Intelligence with optional Inner QR defense to make products 90%+ counterfeit-safe and build verified customer loyalty.
            </p>
            <div className="mt-4 flex justify-center">
              <Link
                to="/application-note"
                className="px-4 py-2 rounded-lg font-semibold border-2 transition-all duration-200"
                style={{ color: '#0A2A4A', borderColor: '#0A2A4A' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#0A2A4A';
                  e.currentTarget.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#0A2A4A';
                }}
              >
                Read the Application Note
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {NEWS_ARTICLES.map((article, idx) => (
              <NewsCard key={idx} article={article} />
            ))}
          </div>

          <div className="mt-10 bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <h3 className="text-xl font-bold mb-3" style={{ color: '#0A2A4A' }}>
              What Pureaum changes
            </h3>
            <ul className="space-y-2 text-sm" style={{ color: '#2B2B2B' }}>
              <li>
                <strong style={{ color: '#0A2A4A' }}>Cloud Scan Intelligence (primary):</strong> duplicate scan detection, geo-velocity, suspicious clusters, post-consumption scanning, retailer hotspot signals, automated alerts.
              </li>
              <li>
                <strong style={{ color: '#0A2A4A' }}>Outer QR:</strong> public verify layer (read-only) for shelf and post-purchase checks.
              </li>
              <li>
                <strong style={{ color: '#0A2A4A' }}>Inner QR (optional second line):</strong> consume/activate proof + loyalty hooks; not required for verification but strengthens resistance.
              </li>
              <li>
                <strong style={{ color: '#0A2A4A' }}>Outcome:</strong> Program-level deployment targets 90%+ counterfeit-safe performance (no absolute guarantees).
              </li>
            </ul>
          </div>
        </div>
      </section>


      {/* CTA STRIP */}
      <section id="talk" className="py-16 bg-white border-t border-gray-100">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div>
              <h3 className="text-xl sm:text-2xl font-bold mb-2" style={{ color: '#0A2A4A' }}>
                Protect your brand at the point of purchase
              </h3>
              <p className="text-sm" style={{ color: '#2B2B2B' }}>
                Deploy Pureaum with minimal packaging change and start reducing risk in days.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/trial-registration"
                className="w-full sm:w-auto px-6 py-3 rounded-lg font-semibold transition-colors duration-200 text-center"
                style={{ backgroundColor: '#FF7A29', color: 'white' }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = '#E6691F')
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = '#FF7A29')
                }
              >
                Start Free Trial
              </Link>
              <Link
                to="/contact-sales"
                className="w-full sm:w-auto px-6 py-3 rounded-lg font-semibold border-2 transition-all duration-200 text-center"
                style={{ color: '#0A2A4A', borderColor: '#0A2A4A' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#0A2A4A';
                  e.currentTarget.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#0A2A4A';
                }}
              >
                Contact sales
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12" style={{ backgroundColor: '#2B2B2B' }}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <div className="font-bold text-xl mb-3" style={{ color: '#F4F4F5' }}>
            Pureaum
          </div>
          <div className="text-sm mb-6" style={{ color: '#F4F4F5' }}>
            sales@pureaum.com
          </div>
          <div className="flex justify-center space-x-8 text-sm mb-6">
            <Link
              to="/privacy"
              className="transition-colors duration-200"
              style={{ color: '#F4F4F5' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#00C2D1')}
              onMouseLeave={(e) => (e.currentTarget.style.color = '#F4F4F5')}
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="transition-colors duration-200"
              style={{ color: '#F4F4F5' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#00C2D1')}
              onMouseLeave={(e) => (e.currentTarget.style.color = '#F4F4F5')}
            >
              Terms
            </Link>
          </div>
          <div className="text-xs" style={{ color: '#F4F4F5' }}>
            (c) 2025 Pureaum
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
